// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b98d53c1","239":"9229c409","732":"cfb155f1"}[chunkId] + ".chunk.js";
};